import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {IEditAddress} from '../../shared/model/interface/edit-address.model.interface';
import {INewAddress} from '../../shared/model/interface/new-address.interface';
import {IAddressTypeList} from '../../shared/model/interface/address-type.model.interface';
import {Observable} from "rxjs";
import {IAddressVerificationList} from "../../shared/model/interface/address-verification.model.interface";

@Injectable({
  providedIn: 'root'
})
export class AddressService {
  private static readonly URL = environment.backendUrl + '/addresses/';


  constructor(private httpClient: HttpClient) {
  }

  updateAddress(addressId: number, address: IEditAddress) {
    return this.httpClient.put(AddressService.URL + `${addressId}/update`, address);
  }

  createAddress(customerId: number, payload: INewAddress) {
    return this.httpClient.post(AddressService.URL + `customers/${customerId}/create`, payload);
  }

  getAddressTypes() {
    return this.httpClient.get<IAddressTypeList>(AddressService.URL + 'types');
  }

  deleteAddress(addressId: number) {
    return this.httpClient.delete(AddressService.URL + `${addressId}/delete`);
  }

  verifyAddresses(addresses: string[]): Observable<IAddressVerificationList> {
    return this.httpClient.post<IAddressVerificationList>(AddressService.URL + `verify`, addresses);
  }
}
